/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@modules/business-accounts/services/auth/auth.service';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

declare const MPFingerprint: any;

@Injectable({
  providedIn: 'root',
})
export class MonitorService {
  constructor(private readonly http: HttpClient, private readonly authService: AuthService) {}

  monitorData!: any;
  geoIp!:any;
  async fetchClientIp() {
    const response = await firstValueFrom(
      this.http.get(`${environment.apiUrl}/business-accounts/v1/web-client-info`, {
        headers: this.authService.buildHeaders(),
      })
    );
    return response;
  }
  async getData() {
    const response = await MPFingerprint.getData(true, true);
    return response;
  }

  async startMonitorData() {
    if (!this.monitorData) {
      const monitorData = await this.getData();
      this.geoIp = await this.fetchClientIp();
      monitorData['Geoip'] = this.geoIp;
      this.monitorData = monitorData;
      console.log('Monitor data: ', this.monitorData);
    }
  }
}
